"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationErrorPage = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var Header_1 = require("../navigator/Header");
var Footer_1 = require("../navigator/Footer");
var ApplicationErrorPage = /** @class */ (function (_super) {
    __extends(ApplicationErrorPage, _super);
    function ApplicationErrorPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApplicationErrorPage.prototype.render = function () {
        var params = new URLSearchParams(window.location.search);
        var error = params.get('e');
        return (React.createElement(React.Fragment, null,
            React.createElement(Header_1.Header, null),
            React.createElement("div", { className: "journey-content error-page" },
                React.createElement("div", { className: "journey-questions" },
                    React.createElement("div", { className: "panel" },
                        React.createElement("p", { className: "text-center text-uppercase mt-2 mb-0 error-title" }, "Application error"),
                        React.createElement("img", { className: "d-block mx-auto mb-5", src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flourish-error.svg"), alt: "Error" }),
                        React.createElement("h2", { className: "text-center mt-3 mb-5 error-text" }, error || 'We are experiencing some technical issues, please come back later')))),
            React.createElement(Footer_1.Footer, null)));
    };
    return ApplicationErrorPage;
}(React.Component));
exports.ApplicationErrorPage = ApplicationErrorPage;
//# sourceMappingURL=ApplicationErrorPage.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/pages/ApplicationErrorPage.js
// module id = 2547
// module chunks = 0